import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import Authentication from './pages/auth/authentication';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <Authentication/>
    <App />
    </BrowserRouter>
   
  </React.StrictMode>
);

// reportWebVitals();
